import cookie from '../module/cookie.js'

const COOKIE_NAME = 'cartamount'
const SELECTOR = '[data-cart-counter]'

function getCartAmount() {
  return parseInt(cookie.get(COOKIE_NAME), 10) || 0
}

function update() {
  const amount = getCartAmount()

  document.querySelectorAll(SELECTOR).forEach((counter) => {
    counter.textContent = amount
    counter.classList.toggle('d-none', amount <= 0)
  })
}

function init() {
  update()

  document.addEventListener('cart.line.added', update)
  window.addEventListener('pageshow', update)
}

export default {
  init,
  update,
}
